import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="no-contextmenu"
export default class extends Controller {
  connect() {
    this.element.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
  }
}
